export default function MapScreen({
  headerInfo,
  btns,
  writeIcons,
  mapElement,
}) {
  return (
    <div
      style={{
        backgroundColor: "#eaeaea",
        flex: headerInfo.ter?.id && btns ? 1 : 0,
        overflow: "hidden",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
          borderBottom: "solid 3px #dedede",
        }}
      >
        {writeIcons()}
      </div>
      <div
        ref={mapElement}
        className="map-container mapBox"
        style={{
          width: "100%",
          height: "100%",
          left: 0,
          top: 0,
        }}
      />
    </div>
  );
}
